import { render, staticRenderFns } from "./toubaoxinxi.vue?vue&type=template&id=4901c86d&"
import script from "./toubaoxinxi.vue?vue&type=script&lang=js&"
export * from "./toubaoxinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports